import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useOrderContext } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { SqFieldCard } from './SqFieldCard';
import { SqQrCode } from '../SqQrCode';

export const SqPaymentFields: React.FC = () => {
  const { t: tPayment } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_details',
  });
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.sq',
  });

  const {
    order,
    requisites,
    currencySymbol,
    requisitesBank,
    formattedPaymentFields,
    shouldShowQrCode,
    paymentTypeFlags: { qrCodeUrl },
  } = useOrderContext();

  const [changeAmountConfirmed, setChangeAmountConfirmed] = useState(
    order.amount === order.initialAmount,
  );

  return (
    <div className="tw-flex tw-flex-col tw-gap-[10px]">
      {!changeAmountConfirmed && (
        <div className="tw-fixed tw-inset-0 tw-bg-black/70 tw-z-[5]" />
      )}

      <div
        className={!changeAmountConfirmed ? 'tw-relative tw-z-[6]' : undefined}
      >
        <SqFieldCard
          label={tPayment('amount')}
          value={`${order.amount} ${currencySymbol}`}
          copyValue={String(order.amount)}
        />
        {!changeAmountConfirmed && (
          <div className="tw-mt-2 tw-bg-white tw-rounded-xl tw-p-4 tw-shadow-lg">
            <span className="tw-absolute tw-left-6 tw-text-white tw-text-xl tw-leading-none tw-select-none tw--mt-7">
              {'▲'}
            </span>
            <p className="tw-text-sm tw-text-gray-800 tw-leading-5 tw-mb-3">
              {t('change_amount.description')}
            </p>
            <button
              className="tw-bg-blue-500 tw-text-white tw-text-sm tw-font-semibold tw-rounded-full tw-px-5 tw-py-2 tw-border-none tw-cursor-pointer"
              onClick={() => setChangeAmountConfirmed(true)}
            >
              {t('change_amount.confirm')}
            </button>
          </div>
        )}
      </div>

      {formattedPaymentFields.map((field) => (
        <SqFieldCard
          key={field.name}
          name={field.name}
          label={field.label}
          value={field.value}
          type={field.type}
        />
      ))}

      {shouldShowQrCode && (
        <div>
          <SqQrCode
            data={requisites?.paymentLink}
            imageUrl={qrCodeUrl}
            bank={requisitesBank}
          />
        </div>
      )}
    </div>
  );
};
